import ContentSkeleton from './content-skeleton';

const ProductListSkeleton: React.FC = () => {
  return (
    <div className="bg-surface-100-bg">
      <div className="max-w-full overflow-hidden">
        <div className="whitespace-nowrap overflow-hidden flex w-[477px] pb-5">
          {new Array(6).fill(1).map((_item, index) => {
            return (
              <div
                key={`content-product-${index}`}
                className="w-[56px] h-[30px] bg-surface-200-bg skeleton rounded-2xl mr-5 first:ml-2.5 last:mr-2.5"
              />
            );
          })}
        </div>
      </div>
      <ContentSkeleton />
    </div>
  );
};

export default ProductListSkeleton;
